import React from "react";
import { Navigate } from "react-router-dom";
// import Faq from "../admin/Faq";
import PaymentDetails from "../../admin/groupConfig/PaymentDetails/PaymentDetails";
import RegistrationCode from "../../admin/groupConfig/RegistrationCode";
import HelpPage from "../../admin/help/HelpPage";
import MembershipCard from "../../admin/members/MembershipCard/MembershipCard";
import CreateChant from "../../admin/content/chants/CreateChants";

import MembershipForm from "../../authentication/MembershipForm";
import Container from "../../admin/website/Container";
import CreateItem from "../../admin/store/create";
import AppSettingsContainer from "../../admin/groupConfig/AppSetting/AppSettingsContainer";

import CreatePartners from "../../admin/partners/CreatePartner";
import Welcome from "../../admin/content/Welcome";
import CreateLocations from "../../admin/locations/CreateLocation/CreateLocations";
import Members from "../../admin/members/Members";
import Safety from "../../admin/members/Safety/Safety";
import Packages from "../../admin/members/Packages";
import Promote from "../../admin/members/Promote/Promote";
import PurchasesReport from "../../admin/purchases/PurchasesReport";
import GroupDesign from "../../admin/groupConfig/GroupDesign/GroupDesign";
import Leaderboard from "../../admin/members/Leaderboard/Leaderboard";
import Merchandise from "../../admin/store/Merchandise/Merchandise";
import StoreSettings from "../../admin/store/Settings/StoreSettings";
import Orders from "../../admin/store/Orders/Orders";
import Locations from "../../admin/locations/Locations";
import AdminGallery from "../../admin/gallery/AdminGallery";
import AdminPolls from "../../admin/content/AdminPolls/AdminPolls";
import AdminGiveaways from "../../admin/content/AdminGiveaways/AdminGiveaways";
import AdminPollVotes from "../../admin/content/AdminPolls/AdminPollVotes";
import AdminGiveawayEntries from "../../admin/content/AdminGiveaways/AdminGiveawayEntries";
import AdminPollCreate from "../../admin/content/AdminPolls/CreatePoll/CreatePoll";
import CreateAdminGiveaway from "../../admin/content/AdminGiveaways/CreateAdminGiveaway/CreateGiveaway";
import AdminChants from "../../admin/content/chants/AdminChants";
import Directory from "../../admin/directory";
import Onboard from "../../admin/members/Onboard";
import PackageForm from "../../admin/members/Packages/PackageForm";
import { Partners } from "../../admin/partners";
import {
  TicketsTable,
  TicketDetails,
  CreateTicket,
  UpdateMatches,
} from "../../admin/tickets";
import EventForm from "../../admin/content/Events/EventForm/EventForm";
import EventsList from "../../admin/content/Events/EventsList/EventsList";
import StadiumSetup from "../../admin/stadium/StadiumSetup";
import Referrals from "../../admin/referrals/Referrals";

export const adminRoutes = [
  { path: "/admin/content", element: <EventsList /> },
  {
    path: "/admin/content/:mode/:group?/:id?",
    element: <EventForm />,
  },

  { path: "/admin/content/polls", element: <AdminPolls /> },
  { path: "/admin/content/polls/create", element: <AdminPollCreate /> },
  { path: "/admin/content/polls/edit/:pollId?", element: <AdminPollCreate /> },
  { path: "/admin/content/polls/:pollId", element: <AdminPollVotes /> },

  { path: "/admin/content/giveaways", element: <AdminGiveaways /> },
  { path: "/admin/content/giveaways/create", element: <CreateAdminGiveaway /> },
  {
    path: "/admin/content/giveaways/:giveawayId",
    element: <AdminGiveawayEntries />,
  },
  {
    path: "/admin/content/giveaways/:giveawayId/edit",
    element: <CreateAdminGiveaway />,
  },
  {
    path: "/admin/directory/:action?",
    element: <Directory />,
  },
  // { path: "/admin/promote", component: Promote, exact: true },
  { path: "/admin/membershipcard", element: <MembershipCard /> },
  { path: "/admin/members/leaderboard/:action?", element: <Leaderboard /> },
  {
    path: "/admin/members/purchaseReport",
    element: <PurchasesReport />,
  },
  { path: "/admin/members/all", element: <Members /> },
  { path: "/admin/members", element: <Navigate to="/admin/members/all" /> },
  { path: "/admin/members/safety", element: <Safety /> },
  {
    path: "/admin/members/acceptRequest/:id/:group",
    element: <Members />,
  },
  {
    path: "/admin/members/packages/:action?",
    element: <Packages />,
  },
  {
    path: "/admin/members/packages/create",
    element: <PackageForm />,
  },
  {
    path: "/admin/members/packages/edit/:id",
    element: <PackageForm />,
  },
  {
    path: "/admin/members/onboard/:action?",
    element: <Onboard />,
  },

  { path: "/admin/members/promote/:action?", element: <Promote /> },

  { path: "/admin/store/create", element: <CreateItem /> },
  { path: "/admin/store/orders", element: <Orders /> },
  { path: "/admin/store/merch", element: <Merchandise /> },
  { path: "/admin/store/settings", element: <StoreSettings /> },
  { path: "/admin/store/edit/:id", element: <CreateItem /> },
  {
    path: "/admin/registrationCode",
    element: <RegistrationCode />,
  },
  { path: "/admin/groupSettings", element: <GroupDesign /> },
  // { path: "/admin/faq", element: <Faq },
  { path: "/admin/chants/create", element: <CreateChant /> },
  { path: "/admin/appSettings", element: <AppSettingsContainer /> },
  { path: "/admin/help", element: <HelpPage /> },
  {
    path: "/admin/chants/edit/:group/:id",
    element: <CreateChant />,
  },
  { path: "/admin/gallery", element: <AdminGallery /> },
  { path: "/admin/welcome", element: <Welcome /> },
  { path: "/admin/content/locations", element: <Locations /> },
  {
    path: "/admin/content/locations/create",
    element: <CreateLocations />,
  },
  {
    path: "/admin/content/locations/edit/:id",
    element: <CreateLocations />,
  },
  { path: "/admin/chants", element: <AdminChants /> },
  { path: "/admin/chants/archive", element: <AdminChants /> },
  { path: "/admin/partners/add", element: <CreatePartners /> },
  {
    path: "/admin/partners/edit/:id",
    element: <CreatePartners />,
  },
  { path: "/admin/partners/:path", element: <Partners /> },

  //Tickets
  { path: "/admin/tickets/create", element: <CreateTicket /> },
  { path: "/admin/tickets/:tab", element: <TicketsTable /> },
  { path: "/admin/tickets/:group/:id", element: <TicketDetails /> },
  { path: "/admin/tickets/edit/:group/:id", element: <CreateTicket /> },
  { path: "/admin/tickets/update", element: <UpdateMatches /> },

  { path: "/admin/website/:tab", element: <Container /> },
  { path: "/admin/paymentDetails", element: <PaymentDetails /> },
  {
    path: "/admin/members/:groupName/add",
    element: <MembershipForm />,
  },

  { path: "/admin/stadium/setup", element: <StadiumSetup /> },
  { path: "/admin/referrals", element: <Referrals /> },
  {
    path: "/login",
    element: <Navigate to="/admin/content" replace />,
  },
  { path: "/", element: <Navigate to="/admin/members" replace /> },
];
